import { extensionBridge } from "../bridge/ExtensionBridgeClient.ts";
import { fetchSourceBridge } from "./SourceHttp.ts";
import { NetworkError } from "../network/types.ts";
export { getSourceTransport } from "./SourceSession.ts";
export type { SourceTransportMode } from "./SourceSession.ts";

export async function fetchSourceHtml(
  sourceId: string,
  url: string,
  method: "GET" | "POST" = "GET",
): Promise<string> {
  try {
    const response = await fetchSourceBridge(url, {
      sourceId,
      method,
      responseType: "text",
      credentials: "include",
    });
    if (typeof response.data !== "string")
      throw new NetworkError("INVALID_RESPONSE", "No se pudo obtener la fuente.");
    if (response.status >= 400)
      throw new NetworkError(
        "HTTP_ERROR",
        `${method} ${url} · HTTP ${response.status}`,
        response.status,
        response.transport,
      );
    return response.data;
  } catch (error) {
    // Preserve visible, user-verified Bokugen sessions; never silently send challenges to the Worker.
    if (
      sourceId === "bokugen" &&
      method === "GET" &&
      error instanceof NetworkError &&
      error.transport === "extension" &&
      (error.code === "CHALLENGE_REQUIRED" || error.status === 403)
    )
      return extensionBridge.readSourceDocument(url);
    throw error;
  }
}
